"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.addOnFactory = addOnFactory;
var _constants = require("../constants");
var _addOns = require("../utils/add-ons.utils");
var _pax = require("../utils/pax.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _trim2 = _interopRequireDefault(require("lodash/trim"));
function addOnFactory(addOn, cart, currencyStore, lang) {
  var _addOn$name, _addOn$prices, _addOn$description, _addOn$headline, _addOn$name2, _addOn$tag, _addOn$note;
  var accessKey = (0, _toLower2.default)((0, _trim2.default)(addOn === null || addOn === void 0 ? void 0 : (_addOn$name = addOn.name) === null || _addOn$name === void 0 ? void 0 : _addOn$name.en)).replace(/[\s_-]/g, '');
  var isAddOnApplied = !!cart;
  var prices = isAddOnApplied ? cart === null || cart === void 0 ? void 0 : cart.package : addOn === null || addOn === void 0 ? void 0 : (_addOn$prices = addOn.prices) === null || _addOn$prices === void 0 ? void 0 : _addOn$prices[0];
  var oldPrice = (0, _addOns.formatAddonPrice)({
    price: prices === null || prices === void 0 ? void 0 : prices.firstTotalPrice,
    currencyStore: currencyStore
  });
  var newPrice = (0, _addOns.formatAddonPrice)({
    price: prices === null || prices === void 0 ? void 0 : prices.totalPrice,
    currencyStore: currencyStore
  });
  return {
    id: addOn === null || addOn === void 0 ? void 0 : addOn.packageId,
    type: addOn === null || addOn === void 0 ? void 0 : addOn.type,
    isAddOnApplied: isAddOnApplied,
    cartId: cart === null || cart === void 0 ? void 0 : cart.cartId,
    hasTnC: !!_constants.ADDON_TNC_MAP[accessKey],
    accessKey: accessKey,
    currency: addOn === null || addOn === void 0 ? void 0 : addOn.currency,
    description: addOn === null || addOn === void 0 ? void 0 : (_addOn$description = addOn.description) === null || _addOn$description === void 0 ? void 0 : _addOn$description[lang],
    headline: addOn === null || addOn === void 0 ? void 0 : (_addOn$headline = addOn.headline) === null || _addOn$headline === void 0 ? void 0 : _addOn$headline[lang],
    name: addOn === null || addOn === void 0 ? void 0 : (_addOn$name2 = addOn.name) === null || _addOn$name2 === void 0 ? void 0 : _addOn$name2[lang],
    iconUrl: addOn === null || addOn === void 0 ? void 0 : addOn.iconUrl,
    tag: addOn === null || addOn === void 0 ? void 0 : (_addOn$tag = addOn.tag) === null || _addOn$tag === void 0 ? void 0 : _addOn$tag[lang],
    note: addOn === null || addOn === void 0 ? void 0 : (_addOn$note = addOn.note) === null || _addOn$note === void 0 ? void 0 : _addOn$note[lang],
    priceId: (0, _get2.default)(addOn, 'prices[0].priceId', ''),
    showType: (0, _get2.default)(addOn, 'prices[0].showType', ''),
    uiType: addOn === null || addOn === void 0 ? void 0 : addOn.uiType,
    oldPrice: (0, _pax.removeTrailingZeroFromPrice)(oldPrice),
    totalPrice: (0, _pax.removeTrailingZeroFromPrice)(newPrice),
    imageUrl: addOn === null || addOn === void 0 ? void 0 : addOn.imageUrl,
    placement: addOn === null || addOn === void 0 ? void 0 : addOn.placement
  };
}